import React from 'react'
import PropTypes from 'prop-types'
import { Avatar } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { alpha } from '@material-ui/core/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const BACKGROUND_OPACITY = 0.08
const useStyles = makeStyles({
  avatar: {
    height: (props) => (props.size === 'lg' ? 80 : 40),
    width: (props) => (props.size === 'lg' ? 80 : 40),
    backgroundColor: (props) => alpha(props.color, BACKGROUND_OPACITY),
  },
  icon: {
    fontSize: (props) => (props.size === 'lg' ? 28 : 14),
  },
})

const AvatarIcon = (props) => {
  const { icon, color } = props
  const styles = useStyles(props)

  return (
    <Avatar className={styles.avatar}>
      <FontAwesomeIcon
        icon={icon}
        color={color}
        className={styles.icon}
      />
    </Avatar>
  )
}

AvatarIcon.propTypes = {
  icon: PropTypes.any.isRequired,
  color: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['sm', 'lg']),
}
export default AvatarIcon
